import React, { useEffect, useState } from 'react';
import { FaHeart, FaRegHeart, FaShareAlt } from 'react-icons/fa';
import { useAuth } from '../AuthContext';

function CarCard({ car, onClick, loggedInUser, saved: initiallySaved = false }) {
  const { user } = useAuth();
  const [saved, setSaved] = useState(initiallySaved);
  const [saving, setSaving] = useState(false);
  const [showToast, setShowToast] = useState('');

  useEffect(() => {
    setSaved(initiallySaved);
  }, [initiallySaved]);

  const showTempToast = (message) => {
    setShowToast(message);
    setTimeout(() => setShowToast(''), 2000);
  };

  const toggleSave = async (e) => {
    e.stopPropagation();
    if (!user?.id) {
      showTempToast('Sign in to save cars');
      return;
    }

    if (saved) {
      const confirmUnsave = window.confirm("Remove this car from your saved list?");
      if (!confirmUnsave) return;
    }

    if (saving) return;
    setSaving(true);

    try {
      const method = saved ? 'DELETE' : 'POST';
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/saved`, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: user.id, carId: car.id })
      });

      if (res.ok) setSaved(!saved);
      else console.error('Failed to toggle saved state');
    } catch (err) {
      console.error('Error saving car:', err);
    } finally {
      setSaving(false);
    }
  };

const handleShare = async (e) => {
  e.stopPropagation();
  const url = `${window.location.origin}/car/${car.id}`;

  if (navigator.share) {
    try {
      await navigator.share({
        title: `${car.year} ${car.make} ${car.model}`,
        url: url
      });
    } catch (err) {
      console.error('Share failed:', err);
    }
  } else {
    // fallback for unsupported browsers
    navigator.clipboard.writeText(url)
      .then(() => showTempToast('Link copied to clipboard!'))
      .catch(() => showTempToast('Failed to copy link'));
  }
};


  return (
    <div
      onClick={() => onClick(car)}
      style={{
        border: '1px solid #0097A7',
        padding: '1rem',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 10px rgba(0, 151, 167, 0.15)',
        cursor: 'pointer',
        position: 'relative',
        transition: 'transform 0.2s'
      }}
    >
      {/* Toast */}
      {showToast && (
        <div style={{
          position: 'absolute',
          bottom: '10px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#333',
          color: '#fff',
          padding: '0.5rem 1rem',
          borderRadius: '6px',
          fontSize: '0.85rem',
          boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
          zIndex: 5,
          opacity: showToast ? 1 : 0,
          transition: 'opacity 0.3s ease'
        }}>
          {showToast}
        </div>
      )}

      <img
        src={car.imageUrl}
        alt="Car"
        style={{
          width: '100%',
          borderRadius: '6px',
          marginBottom: '0.5rem',
          objectFit: 'cover',
          height: '180px'
        }}
      />
      <h4 style={{ margin: '0.25rem 0' }}>
        {car.year} {car.make} {car.model} {car.trim}
      </h4>
      <p style={{ fontWeight: 'bold', color: '#004D40' }}>
        ${car.price.toLocaleString()}
      </p>
      <p style={{ color: '#666' }}>{car.mileage.toLocaleString()} miles</p>

      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: '#888',
        marginTop: '0.25rem'
      }}>
        <span>{car.dealerCity}, {car.dealerState}</span>

        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
          <button
            onClick={handleShare}
            style={{
              background: 'none',
              border: 'none',
              color: '#555',
              cursor: 'pointer',
              fontSize: '1.2rem'
            }}
            title="Share car"
          >
            <FaShareAlt />
          </button>

          <div
            onClick={toggleSave}
            style={{
              fontSize: '1.4rem',
              color: saved ? 'red' : '#888',
              cursor: 'pointer'
            }}
            title={saved ? 'Unsave car' : 'Save car'}
          >
            {saved ? <FaHeart /> : <FaRegHeart />}
          </div>
        </div>
      </div>

      {car.priceLabel && (
        <div style={{
          marginTop: '0.5rem',
          display: 'inline-block',
          padding: '0.3rem 0.6rem',
          borderRadius: '999px',
          fontWeight: 'bold',
          fontSize: '0.85rem',
          backgroundColor:
            car.priceLabel === 'Great Deal' ? '#4caf50' :
              car.priceLabel === 'Fair Price' ? '#ffc107' :
                car.priceLabel === 'Overpriced' ? '#f44336' : '#ccc',
          color: car.priceLabel === 'Fair Price' ? '#000' : '#fff'
        }}>
          {car.priceLabel}
        </div>
      )}
    </div>
  );
}

export default CarCard;
